import { $qs } from 'fxdom/es';
import { defnCommonEvents } from '../../../../../modules/Creator/Setting/F/common_event.js';

if ($qs('#creator_settings')) {
  defnCommonEvents($qs('body.creator-settings'));
  // go($qs('body.creator-settings #creator_settings_menu .iscroll_wrapper'), (iscroll_wrapper_el) => {
  //   new IScroll(iscroll_wrapper_el, { mouseWheel: true, scrollbars: true, fadeScrollbars: true });
  // });
}
